import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { asyncConnect } from 'redux-connect';
import { reduxForm } from 'redux-form';
import * as csvActions from 'redux/modules/csv';
import { bindActionCreators } from 'redux';
import 'react-virtualized/styles.css';
import { Grid } from 'react-virtualized';


const validate = values => {
	const errors = {}
	/*if (!values.csv) {
		errors.csv = 'Required'
	}*/
	return errors
}



@translate(['common'])
@asyncConnect([{
	promise: ({ store: { dispatch, getState } }) => {
		const promises = [];
		promises.push(dispatch(csvActions.loadCr()));
		return Promise.all(promises);
	}
}])

@connect(
	state => ({
		loading: state.csv.loading,
		successCSV: state.csv.successCSV,
		errorCSV: state.csv.errorCSV,

		successNotice: state.csv.successNotice,
		errorNotice: state.csv.errorNotice,

		crList: state.csv.crList
	}),
	dispatch => bindActionCreators(csvActions, dispatch)
)

@reduxForm({
	form: 'importCSV',
	fields: ['csv', 'notice'],
	validate
})
export default class ImportCSV extends Component {

	constructor(props) {
		super(props);
		this.state = {
			noticesExist: { install: false, serveur: false, cansts: false }
		};
		this.readFile = this.readFile.bind(this); //Binding to `this`
		this.checkNoticesExist = this.checkNoticesExist.bind(this);
	}

	componentDidMount() {
		this.checkNoticesExist();
	}

	checkNoticesExist() {
		fetch('/api/csv/checkNotices', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({})
		}).then(response => response.json())
			.then(data => this.setState({ noticesExist: data }))
			.catch(() => {});
	}

	readFile(event) {

	}


	readNotice(event) {

	}



	render() {
		const {
			fields: { csv, notice },
			handleSubmit,
			resetForm,
			submitting,
			importCSV,
			importNotice,
			values,
			errorCSV,
			successCSV,
			crList,
			pristine,
			invalid,
			t
		} = this.props

		return (
			<div className="container">
				<br />
				<form onSubmit={handleSubmit} className="col-xs-6" method="post" encType="multipart/form-data">
					<div>
						<h3>{t("importCSV.import_csv")}</h3>
						<div>
							<input ref="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
								className="form-control" type="file" {...csv} value={null}
								onChange={this.readFile} />
						</div>
					</div>
					<div>
						<br />
						<button className="btn btn-primary" type="submit" disabled={pristine || invalid || submitting}
							onClick={handleSubmit(() => {
								var file = values.csv[0];
								var reader = new FileReader();
								reader.onload = function (evt) {
									var resultText = evt.target.result;
									importCSV(resultText);
								}.bind(this);

								reader.readAsText(file);

							})}>
							{submitting ? <i /> : <i />} {t("importCSV.send_csv")}
	          			</button>
					</div>

					<br />

					<p>
						{errorCSV &&
							<div className="alert alert-danger" role="alert">
								<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
								{' '}
								{errorCSV}
							</div>}

						{successCSV &&
							<div className="alert alert-success" role="alert">
								<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
								{' '}
								{successCSV}
							</div>}
					</p>


					<br />

					<div>
						<h3>{t("importCSV.import_install_notice")}</h3>
						<div>
							<input
								className="form-control" type="file" {...notice} value={null}
								accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
									text/plain, application/pdf"
								onChange={this.readNotice} 
							/>
						</div>
					</div>
					
					<div>
						<br />
						<button className="btn btn-primary" type="submit" disabled={pristine || invalid || submitting}
							onClick={handleSubmit(() => {
								var file = values.notice[0];

								var fd = new FormData();

								fd.append('noticeInstall', file, 'notice.pdf');

								fetch('/api/csv/importNotice', { // Your POST endpoint
									method: 'POST',
									body: fd
								}).then(
									response => response.json() // if the response is a JSON object
								).then(
									success => alert(t("importCSV.notice_uploaded")) // Handle the success response object
								).catch(
									error => alert(t("main.error"))// Handle the error response object
								);


								//importNotice(file);


							})}>
							{submitting ? <i /> : <i />} {t("importCSV.send_notice")}
	          			</button>
						{this.state.noticesExist.install &&
						<button className="btn btn-danger btn-sm" style={{marginLeft: '10px'}} type="button"
							onClick={() => {
								if (window.confirm(t('notice.confirm_delete'))) {
									fetch('/api/csv/deleteNotice', {
										method: 'POST',
										headers: { 'Content-Type': 'application/json' },
										body: JSON.stringify({ type: 'install' })
									}).then(response => response.json())
										.then(() => { alert(t('notice.notice_deleted')); this.checkNoticesExist(); })
										.catch(() => alert(t('main.error')));
								}
							}}>
							<i className="fa fa-trash" /> {t("main.delete")}
						</button>}
					</div>

					<br /><br />


					<div>
						<h3>{t("importCSV.import_server_notice")}</h3>
						<div>
							<input
								className="form-control" type="file" {...notice} value={null}
								accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
									text/plain, application/pdf"
								onChange={this.readNotice} />
						</div>
					</div>
					
					<div>
						<br />
						<button className="btn btn-primary" type="submit" disabled={pristine || invalid || submitting}
							onClick={handleSubmit(() => {
								var file = values.notice[0];

								var fd = new FormData();

								fd.append('noticeServer', file, 'notice.pdf');

								fetch('/api/csv/importNotice', { // Your POST endpoint
									method: 'POST',
									body: fd
								}).then(
									response => response.json() // if the response is a JSON object
								).then(
									success => alert(t("importCSV.notice_uploaded")) // Handle the success response object
								).catch(
									error => alert(t("main.error"))// Handle the error response object
								);


								//importNotice(file);


							})}>
							{submitting ? <i /> : <i />} {t("importCSV.send_notice")}
	          			</button>
						{this.state.noticesExist.serveur &&
						<button className="btn btn-danger btn-sm" style={{marginLeft: '10px'}} type="button"
							onClick={() => {
								if (window.confirm(t('notice.confirm_delete'))) {
									fetch('/api/csv/deleteNotice', {
										method: 'POST',
										headers: { 'Content-Type': 'application/json' },
										body: JSON.stringify({ type: 'serveur' })
									}).then(response => response.json())
										.then(() => { alert(t('notice.notice_deleted')); this.checkNoticesExist(); })
										.catch(() => alert(t('main.error')));
								}
							}}>
							<i className="fa fa-trash" /> {t("main.delete")}
						</button>}
					</div>

					<br /><br />

					<div>
						<h3>{t("importCSV.import_cansts_notice")}</h3>
						<div>
							<input
								className="form-control" type="file" {...notice} value={null}
								accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
									text/plain, application/pdf"
								onChange={this.readNotice} />
						</div>
					</div>
					
					<div>
						<br />
						<button className="btn btn-primary" type="submit" disabled={pristine || invalid || submitting}
							onClick={handleSubmit(() => {
								var file = values.notice[0];

								var fd = new FormData();

								fd.append('noticeCanSts', file, 'notice.pdf');

								fetch('/api/csv/importNotice', {
									method: 'POST',
									body: fd
								}).then(
									response => response.json()
								).then(
									success => alert(t("importCSV.notice_uploaded"))
								).catch(
									error => alert(t("main.error"))
								);

							})}>
							{submitting ? <i /> : <i />} {t("importCSV.send_notice")}
	          			</button>
						{this.state.noticesExist.cansts &&
						<button className="btn btn-danger btn-sm" style={{marginLeft: '10px'}} type="button"
							onClick={() => {
								if (window.confirm(t('notice.confirm_delete'))) {
									fetch('/api/csv/deleteNotice', {
										method: 'POST',
										headers: { 'Content-Type': 'application/json' },
										body: JSON.stringify({ type: 'cansts' })
									}).then(response => response.json())
										.then(() => { alert(t('notice.notice_deleted')); this.checkNoticesExist(); })
										.catch(() => alert(t('main.error')));
								}
							}}>
							<i className="fa fa-trash" /> {t("main.delete")}
						</button>}
					</div>

					<br /><br />


					{crList.length > 0 &&

						<div>
							<p>
								<b>{t("importCSV.table_content")}  : </b>
								<br />
							</p>

							<div style={{ maxWidth: '100%', overflowX: 'auto' }}>
							<Grid
								width={900}
								height={300}
								columnWidth={120}
								rowHeight={100}
								columnCount={6}
								rowCount={crList.length}
								cellRenderer={({ columnIndex, isScrolling, rowIndex }) => {
									return Object.values(crList[rowIndex])[columnIndex]
								}}
							/>
							</div>
						</div>
					}

				</form>
			</div>
		)
	}
}
